define [], () ->
  ($timeout, ApplicationTemplate, RentappService, $state, $http, RENTAPPLICATION_API_URL, HOST, $uibModal, $compile, $cacheFactory, $filter, Flash) ->
    restrict: "E"
    template: require("./rejectApplication.jade")
    scope: 
      application: "="
    link: (scope, element, attrs) ->
      scope.open_reject_application_modal = () ->
        scope.unit_address = scope.application.unit_address or 'Address not provided'
        scope.email =
          subject: "Application for #{scope.unit_address} Rejected"
          body: """
          Dear #{scope.application.applicant_name}, \n
          Unfortunately, we regret to inform you that your application to live at #{scope.unit_address} was not accepted. For questions about why your application was not accepted, do not reply to this email. Please contact the following: \n
          #{if scope.application.landlord.name then scope.application.landlord.name else ""}
          #{if scope.application.landlord.contact_email then scope.application.landlord.contact_email else ""}
          #{if scope.application.landlord.phone then scope.application.landlord.phone else ""}
          """
          
        $uibModal.open
          scope: scope
          template: require("./rejectApplicationModal/rejectApplicationModal.jade")
          controller: require("./rejectApplicationModal/rejectApplicationModal.coffee")
          windowClass: 'reject-modal'
        .result.then (dueToReports) ->
          scope.dueToReports = dueToReports
          console.log "dueToReports", dueToReports

          # If closed without actions
          if dueToReports == null
            return {}

          # If reason is due to reports
          if dueToReports 
            scope.open_due_to_reports_modal()
          else
            scope.open_due_to_others_modal()

      scope.open_due_to_reports_modal = () ->
        $uibModal.open
          scope: scope
          template: require("./dueToReportsModal/dueToReportsModal.jade")
          controller: require("./dueToReportsModal/dueToReportsModal.coffee")
          windowClass: 'due-to-reports-modal'
        .result.then () ->
          console.log "due to reports done"

      scope.open_due_to_others_modal = () ->
        $uibModal.open
          scope: scope
          template: require("./dueToOthersModal/dueToOthersModal.jade")
          controller: require("./dueToOthersModal/dueToOthersModal.coffee")
          windowClass: 'due-to-others-modal'
        .result.then () ->
          console.log "due to others done"

        



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/rejectApplication/rejectApplication.coffee